<template>
  <div id="RegisterByMonth"></div>
</template>
<script>
import G2 from '@antv/g2';
import chartMixin from '../../chartMixin';

export default {
  name: 'RegisterByMonth',
  props: {
    changeReportMonthHandle: {
      type: Function,
    },
  },
  mixins: [chartMixin],
  data() {
    return {
      demoData: [{ month: 1, count: 421 }],
    };
  },
  methods: {
    initData() {
      this.chart = new G2.Chart({
        container: 'RegisterByMonth',
        forceFit: true,
        height: this.height,
        padding: [30, 20, 30, 50],
      });
      this.chart
        .source(this.data, {
          count: {
            alias: '人数',
            formatter: val => {
              if (/\./.test(val)) {
                return '';
              }
              return val;
            },
          },
        })
        .axis('month', {
          label: {
            textStyle: {
              fill: '#333',
            },
          },
        })
        .tooltip({
          showTitle: false,
        })
        .interval()
        .position('month*count')
        .color('#4e82fb')
        .label('count', {
          // position: 'middle',
          offset: 10,
        });
      this.chart.render();
      this.chart.on('plotclick', this.clickHandle);
    },
    clickHandle(ev) {
      let records = this.chart.getSnapRecords({ x: ev.x, y: ev.y });
      if (records && records.length) {
        let data = records[0]._origin;
        this.changeReportMonthHandle(data.month);
      }
    },
  },
};
</script>
